/* Clean Specs Table — two-line rows: Title on top, detail underneath */
(function(){
  // Where to search (safe defaults if theme differs)
  var roots = document.querySelectorAll('.product, main, .product__info, .product__accordion, .product__description, .rte');
  if (!roots.length) roots = [document];

  function looksLikeSpecsTable(t){
    var rows=[...t.rows].slice(0,6);
    if(!rows.length) return false;
    // needs at least two cells in typical rows
    return rows.some(r => r.cells[0] && r.cells[1]);
  }

  function enhance(table){
    if(table.dataset.spxDone) return;
    table.classList.add('spx-specs');

    var rows=[...table.rows];
    rows.forEach(function(r){
      var c0=r.cells[0], c1=r.cells[1];
      if(!c0) return;

      var label=(c0.textContent||'').trim();
      var value = c1 ? c1.innerHTML : '';

      // If this is a section header row (no value or value is just a dash), render a header line
      var isGroup = (!c1 || (c1.textContent||'').trim()==='' || (c1.textContent||'').trim()==='–' || /[:：]\s*$/.test(label));
      if(isGroup){
        // Normalize: use single cell, bold header
        if(c1) c1.remove();
        c0.colSpan = 2;
        c0.innerHTML = '<div class="spx-group-title">'+ label.replace(/[:：]\s*$/,'') +'</div>';
        r.classList.add('spx-group');
        return;
      }

      // Normal row → stack Title (bold) + Value (muted) inside a single cell
      if(c1){
        c1.remove();
      }
      c0.colSpan = 2;
      c0.innerHTML = '<div class="spx-stack"><div class="spx-top">'+ label +
                     '</div><div class="spx-sub">'+ value +'</div></div>';
    });

    table.dataset.spxDone='1';
  }

  // Scan now
  roots.forEach(function(root){
    root.querySelectorAll('table').forEach(function(t){ if(looksLikeSpecsTable(t)) enhance(t); });
  });

  // Scan later (accordions/async content)
  new MutationObserver(function(muts){
    muts.forEach(function(m){
      m.addedNodes && m.addedNodes.forEach(function(n){
        if(n.querySelectorAll) n.querySelectorAll('table').forEach(function(t){ if(looksLikeSpecsTable(t)) enhance(t); });
      });
    });
  }).observe(document.documentElement,{subtree:true,childList:true});
})();

